import { RefundOfferIdDto } from 'types/dtos/refund-offer-id'
import { RefundOfferIdModel } from 'types/models/refund-offer-id'

export const transformRefundOfferIdDto = ({
  refund_offer_id,
}: RefundOfferIdDto): RefundOfferIdModel => ({
  refundOfferId: refund_offer_id,
})
